import React from 'react';

const Tabs = ({ children, active }) => {
  const tabs = children[0]?.props?.children || children?.props?.children;
  const content = children[1]?.props?.children;

  const object = Array.isArray(children)
    ? [
        {
          ...children[0],
          props: {
            ...children[0]?.props,
            children: null,
          },
        },
        {
          ...children[1],
          props: {
            ...children[1]?.props,
            children: null,
          },
        },
      ]
    : {
        ...children,
        props: {
          ...children?.props,
          children: null,
        },
      };

  if (!content && !tabs) {
    return <b style={{ color: 'red' }}>Missing TabPanel or TabContent items</b>;
  }

  if (content && Array.isArray(content)) {
    object[1].props.children = content.map((tab, index) => {
      if (typeof active !== 'undefined') {
        tab = {
          ...tab,
          props: {
            ...tab?.props,
            active: active === index,
          },
        };
      }
      return tab;
    });
  }

  if (tabs && Array.isArray(tabs)) {
    const mappedTabs = tabs?.map((item, index) => {
      if (typeof active !== 'undefined') {
        item = {
          ...item,
          props: {
            ...item?.props,
            active: active === index,
          },
        };
      }
      return item;
    });

    if (Array.isArray(object)) {
      object[0].props.children = mappedTabs;
    } else {
      object.props.children = mappedTabs;
    }
  }

  return <>{object}</>;
};

export default Tabs;
